import React from "react";
import _ from "lodash";

function ProcessingIndicator(props) {
  let style = {
    display: "inline-block",
  };

  _.merge(style, _.get(props, "style", {}));

  let dotStyle = {
    display: "inline-block",
    borderRadius: "100%",
    marginRight: props.gap,
    width: props.size + "px",
    height: props.size + "px",
    backgroundColor: props.color,
    animation: "pulseHide " + props.speed + " infinite ease-in-out both",
  };

  //animation delay must come after animation property
  var dots = _.times(props.dots, function (i) {
    let delay = _.round(_.subtract(props.dots, _.add(1, i) * _.toNumber(props.delay)), 2);
    return <div key={i} style={_.merge({}, dotStyle, { animationDelay: "-" + delay + "s" })}></div>;
  });

  return <div style={style}>{dots}</div>;
}

ProcessingIndicator.defaultProps = {
  dots: 4,
  color: "#FFFFFF",
  gap: 5,
  size: 16,
  speed: "1.6s",
  delay: 0.2,
};

export default ProcessingIndicator;
